import { CodeSerializer } from "./CodeSerializer";
export const serializers = {
  types: {
    code: (props) => <CodeSerializer {...props}/>,
  },
};